import { Component, OnInit } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';
import { Iterminosycondiciones } from '../../services/bodyAll';

@Component({
  selector: 'app-polities',
  templateUrl: './polities.component.html',
  styleUrls: ['./polities.component.scss'],
})
export class PolitiesComponent implements OnInit {
  
  polities:Iterminosycondiciones

  constructor(
  	public modalController: ModalController,
    public navParams: NavParams,

  ) { 
    console.log("params")
    console.log(this.navParams.get('polities'))
    this.polities = this.navParams.get('polities')
  }

  ngOnInit() {}

  //operaciones

  async closeModal(){
    await this.modalController.dismiss()
  }

}
